import { h, render } from "preact";

import "./antd";

import "antd/dist/antd.variable.min.css";
import "./assets/styles/main.scss";

import App from "./App";

render(<App />, document.body);